import { Button, Loading } from "@mozioinc/ui";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { GeneralError } from "../components";
import { googleWalletQuery } from "../utils/query";
import type { TransNamespace } from "../types";

const ReservationsGoogleWalletPage = ({ hashedId }: { hashedId: string }) => {
  const { t } = useTranslation<TransNamespace>("transfer:google-wallet");

  const { data, isPending, isError } = useQuery({
    queryKey: ["reservation-google-wallet", hashedId],
    queryFn: () => googleWalletQuery.getReservationGooglePass(hashedId),
    enabled: true,
  });

  const hasRedirected = useRef(false);

  useEffect(() => {
    if (data && !hasRedirected.current) {
      hasRedirected.current = true;
      window.location.href = data.saveUrl;
    }
  }, [data]);

  if (isPending) {
    return <Loading className="h-screen" />;
  }

  if (isError || !data) {
    return <GeneralError className="h-screen" />;
  }

  return (
    <div className="grid min-h-screen place-items-center px-4 text-center">
      <div className="flex max-w-md flex-col items-center gap-4">
        <h1 className="text-2xl font-semibold">
          {t("Adding your reservation to Google Wallet")}
        </h1>
        <p className="text-neutral-700">
          {t(
            "If Google Wallet did not open automatically, use the button below.",
          )}
        </p>
        <Button onClick={() => (window.location.href = data.saveUrl)}>
          {t("Add to Google Wallet")}
        </Button>
        <p className="text-sm text-neutral-500">
          {t("You can close this window once your pass has been added.")}
        </p>
      </div>
    </div>
  );
};

export default ReservationsGoogleWalletPage;
